export default __webpack_public_path__ + "static/media/fluent_delete-48-filled.7dc36390.svg";